import cx from 'classnames';
import { useContext } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';
import useIsSavedSearchApplied from '~/hooks/srp/useIsSavedSearchApplied';
import ResultTiles from './SimilarResults';
import StyledResultsSection from '../StyledResultSection';

export default function SimilarResultsSection() {
  const {
    similarVehicles: { vehicles }
  } = useContext(InventoryContext);
  const savedSearchIsApplied = useIsSavedSearchApplied();
  const hasSimilarResults = vehicles.length > 0;

  return hasSimilarResults ? (
    <div
      className={cx('flex flex-col gap-2xl sm:gap-3xl', {
        'mt-2xl sm:mt-3xl': savedSearchIsApplied
      })}
    >
      <div className="text-text-strong t-heading-lg sm:t-heading-xl">
        Check out similar vehicles
      </div>
      <StyledResultsSection>
        <ResultTiles vehicles={vehicles} />
      </StyledResultsSection>
    </div>
  ) : null;
}
